import type { CoreFetch } from '~/types/CoreFetch'

export function provideGetNotificationSocketToken(coreFetch: CoreFetch) {
  return (): Promise<string> => {
    return coreFetch.$get<string>('/auth/token/notification/')
  }
}
